import React from 'react';
import { useMenu } from 'hooks';
import {
	Box,
	Checkbox,
	IconButton,
	Menu,
	MenuItem,
	TableCell,
	TableRow,
	Typography
} from '@mui/material';
import { MoreHoriz } from '@mui/icons-material';

const SkillItem = ({
	category,
	isSelectable,
	selectedIds = [],
	handleSelect,
	handleClick,
	handleEditClick,
	handleDeleteClick,
	...props
}) => {
	const { open, anchorEl, handleToggleMenu, handleClose } = useMenu();

	const renderMenu = () => (
		<Menu open={open} onClose={handleClose} anchorEl={anchorEl}>
			<MenuItem onClick={(e) => handleEditClick(category, e)}>Edit</MenuItem>
			<MenuItem onClick={(e) => handleDeleteClick(category, e)}>
				Delete
			</MenuItem>
		</Menu>
	);

	const isSelected = selectedIds.includes(category.id);

	return (
		<TableRow
			hover
			onClick={() => handleClick(category)}
			sx={{ cursor: 'pointer' }}
		>
			{isSelectable && (
				<TableCell>
					<Checkbox
						checked={isSelected ? true : false}
						onChange={() => handleSelect(category)}
						name="topic"
						color="primary"
					/>
				</TableCell>
			)}

			<TableCell>
				<Typography variant="primary.text">{category.name}</Typography>
			</TableCell>
			<TableCell>
				<Typography variant="primary.text">{category.value}</Typography>
			</TableCell>
			<TableCell>
				<Typography variant="primary.text">{category?.description}</Typography>
			</TableCell>
			<TableCell>
				<Typography variant="primary.text">{category.created_at}</Typography>
			</TableCell>
			<TableCell align="right">
				<IconButton
					onClick={(e) => {
						e.stopPropagation();
						handleToggleMenu(e);
					}}
				>
					<MoreHoriz />
				</IconButton>
				{renderMenu()}
			</TableCell>
		</TableRow>
	);
};

export default SkillItem;
